import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { FormDescription } from '@/components/ui/form';
type Props = {
  readonly description?: React.ReactNode;
};
export function AppFormDescription(t0) {
  const $ = _c(2);
  const {
    description
  } = t0;
  if (description == null) {
    return null;
  }
  let t1;
  if ($[0] !== description) {
    t1 = <FormDescription>{description}</FormDescription>;
    $[0] = description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}